const nl = {
  'next-picture': 'volgende foto',
  'prev-picture': 'vorige foto',
  yes: 'ja',
  no: 'nee',
  usp: 'Unieke verkooppunten'
}
const fr = {
  'next-picture': 'photo suivante',
  'prev-picture': 'photo précédente',
  yes: 'oui',
  no: 'non',
  usp: 'Arguments de vente uniques'
}
export const dictionary = lang => (lang === 'fr' ? fr : nl)
